import { isEqual, isObject, transform } from 'lodash'

export const isStringValid = str => {
  if (typeof str != 'undefined' && str != null && str != '') {
    return true
  }
  return false
}

export const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    ;(result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    )
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result
  }, {}) // empty object is the initial value for result object
}

export const groupByObjectArr = (array, key) => {
  const groupBySection = groupBy(array, key)
  let result = []
  const objectArray = Object.entries(groupBySection)

  objectArray.forEach(([key, value]) => {
    result.push({
      categoryGroup: key,
      value,
    })
  })
  return result
}

export const limitStringLength = (string, charLimit) => {
  if (string) {
    if (string.length > charLimit) {
      let trimmedString = string.substring(0, charLimit)
      //retrimm string in case we cut in the middle of a word
      return (
        trimmedString.substr(
          0,
          Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))
        ) + '...'
      )
    }
    return string
  }
}

export const parseUTCDateToLocal = dbDateStr => {
  const dbDate = new Date(dbDateStr)
  const utcDate = new Date(
    Date.UTC(
      dbDate.getFullYear(),
      dbDate.getMonth(),
      dbDate.getDate(),
      dbDate.getHours(),
      dbDate.getMinutes()
    )
  )
  return utcDate
}

export const getTimestampInUTC = () => {
  const nowDate = new Date()
  return (
    nowDate.getUTCFullYear().toString() +
    getDoubleDigitTime(nowDate.getUTCMonth() + 1) +
    getDoubleDigitTime(nowDate.getUTCDate()) +
    getDoubleDigitTime(nowDate.getUTCHours()) +
    getDoubleDigitTime(nowDate.getUTCMinutes()) +
    getDoubleDigitTime(nowDate.getUTCSeconds())
  )
}

const getDoubleDigitTime = time => {
  return (time < 10 ? '0' : '') + time.toString()
}

export const checkIsOdd = value => {
  return value % 2 !== 0
}

// returns the difference between 2 objects
export const difference = (object, base) => {
  const changes = (object, base) => {
    return transform(object, (result, value, key) => {
      if (!isEqual(value, base[key])) {
        if (isObject(value) && isObject(base[key])) {
          result[key] = changes(value, base[key])
        } else {
          result[key] = value
        }
      }
    })
  }
  return changes(object, base)
}

export const splitString = string => {
  // cut the string in half
  const stringArray = string.split(' ')
  const stringArrayLength = stringArray.length
  const stringArrayHalfLength = Math.ceil(stringArrayLength / 2)
  const stringArrayFirstHalf = stringArray.slice(0, stringArrayHalfLength)
  const stringArraySecondHalf = stringArray.slice(
    stringArrayHalfLength,
    stringArrayLength
  )
  const stringFirstHalf = stringArrayFirstHalf.join(' ')
  const stringSecondHalf = stringArraySecondHalf.join(' ')

  return {
    stringFirstHalf,
    stringSecondHalf,
  }
}
